import AllProducts from './allProducts';

export default AllProducts;
